export default __webpack_public_path__ + "static/media/ic_parking.f90e8f33.svg";